// frontend/src/components/EditMemberForm.js
import React, { useState } from 'react';

const EditMemberForm = ({ member, onUpdateMember, onClose, loading }) => {
  const [formData, setFormData] = useState({
    fullName: member.fullName || '',
    isibongo: member.isibongo || '',
    praiseNames: member.praiseNames || '',
    relationship: member.relationship || '',
    birthDate: member.birthDate ? new Date(member.birthDate).toISOString().split('T')[0] : '',
    deathDate: member.deathDate ? new Date(member.deathDate).toISOString().split('T')[0] : '',
    lifeEvents: member.lifeEvents || '',
    photo: member.photo || ''
  });

  const zuluRelationships = [
    { value: 'uBaba', label: 'uBaba (Father)' },
    { value: 'uMama', label: 'uMama (Mother)' },
    { value: 'Umkhulu', label: 'Umkhulu (Grandfather)' },
    { value: 'Ugogo', label: 'Ugogo (Grandmother)' },
    { value: 'uMzala', label: 'uMzala (Cousin)' },
    { value: 'uMalume', label: 'uMalume (Uncle - Mother\'s brother)' },
    { value: 'uBhuti', label: 'uBhuti (Brother)' },
    { value: 'uSisi', label: 'uSisi (Sister)' },
    { value: 'iNdodana', label: 'iNdodana (Son)' },
    { value: 'iNdodakazi', label: 'iNdodakazi (Daughter)' },
    { value: 'uMakoti', label: 'uMakoti (Daughter-in-law)' },
    { value: 'uMkhwenyana', label: 'uMkhwenyana (Son-in-law)' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.fullName || !formData.relationship) {
      alert('Please fill in at least the name and relationship');
      return;
    }

    // Only send changed data to prevent data corruption
    const updateData = {
      fullName: formData.fullName.trim(),
      isibongo: formData.isibongo.trim(),
      praiseNames: formData.praiseNames.trim(),
      relationship: formData.relationship,
      birthDate: formData.birthDate || null,
      deathDate: formData.deathDate || null,
      lifeEvents: formData.lifeEvents.trim(),
      photo: formData.photo.trim() || null
    };

    onUpdateMember(updateData);
  };

  const hasChanges = () => {
    return (
      formData.fullName !== (member.fullName || '') ||
      formData.isibongo !== (member.isibongo || '') ||
      formData.praiseNames !== (member.praiseNames || '') ||
      formData.relationship !== (member.relationship || '') ||
      formData.birthDate !== (member.birthDate ? new Date(member.birthDate).toISOString().split('T')[0] : '') ||
      formData.deathDate !== (member.deathDate ? new Date(member.deathDate).toISOString().split('T')[0] : '') ||
      formData.lifeEvents !== (member.lifeEvents || '') ||
      formData.photo !== (member.photo || '')
    );
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      backgroundColor: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '12px', 
        width: '100%', 
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#92400e' }}>
            ✏️ Edit Family Member
          </h2>
          <button onClick={onClose} style={{ fontSize: '24px', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
        </div>

        {/* Member Info Header */}
        <div style={{
          backgroundColor: '#fef3c7',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <p style={{ color: '#92400e', fontSize: '14px', margin: 0 }}>
            Editing: <strong>{member.fullName}</strong>
            {member.isibongo && ` (${member.isibongo})`}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Igama Eliphelele (Full Name) *
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="Enter full name"
              required
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Isibongo (Clan/Surname)
            </label>
            <input
              type="text"
              name="isibongo"
              value={formData.isibongo}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="e.g., Mthembu, Nkomo, Zulu"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Izithakazelo (Praise Names)
            </label>
            <input
              type="text"
              name="praiseNames"
              value={formData.praiseNames}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="Traditional praise names"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Ubudlelwano (Relationship) *
            </label>
            <select
              name="relationship"
              value={formData.relationship}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              required
            >
              <option value="">Select relationship</option>
              {zuluRelationships.map(rel => (
                <option key={rel.value} value={rel.value}>{rel.label}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                Usuku Lokuzalwa (Birth Date)
              </label>
              <input
                type="date"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleInputChange}
                style={{ 
                  width: '100%', 
                  padding: '8px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px' 
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                Usuku Lokufa (Death Date)
              </label>
              <input
                type="date"
                name="deathDate"
                value={formData.deathDate}
                onChange={handleInputChange}
                style={{ 
                  width: '100%', 
                  padding: '8px', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px' 
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Photo URL (Optional)
            </label>
            <input
              type="url"
              name="photo"
              value={formData.photo}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="https://example.com/photo.jpg"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Izehlakalo Zokuphila (Life Events & Roles)
            </label>
            <textarea
              name="lifeEvents"
              value={formData.lifeEvents}
              onChange={handleInputChange}
              rows="3"
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="e.g., Built homestead, Family leader, Teacher, etc."
            />
          </div>

          {/* Change Indicator */}
          {hasChanges() && (
            <div style={{
              backgroundColor: '#dbeafe',
              border: '1px solid #93c5fd',
              color: '#1e40af',
              padding: '8px 12px',
              borderRadius: '6px',
              fontSize: '12px',
              marginBottom: '16px',
              textAlign: 'center'
            }}>
              📝 Changes detected - ready to save
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button
              type="submit"
              disabled={loading || !hasChanges()}
              style={{
                flex: 1,
                backgroundColor: loading || !hasChanges() ? '#9ca3af' : '#d97706',
                color: 'white',
                padding: '12px',
                border: 'none',
                borderRadius: '6px',
                cursor: loading || !hasChanges() ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {loading ? (
                <>
                  <span style={{ animation: 'spin 1s linear infinite' }}>⏳</span>
                  Updating...
                </>
              ) : (
                <>
                  <span>💾</span>
                  Save Changes
                </>
              )}
            </button>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                flex: 1,
                backgroundColor: '#6b7280',
                color: 'white',
                padding: '12px',
                border: 'none',
                borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              <span>✕</span>
              Cancel
            </button>
          </div>
        </form>

        {/* Safety Note */}
        <div style={{
          backgroundColor: '#fef3c7',
          padding: '12px',
          borderRadius: '8px',
          marginTop: '16px'
        }}>
          <p style={{ fontSize: '12px', color: '#92400e', textAlign: 'center', margin: 0 }}>
            🔒 <strong>Data Protection:</strong> Changes only affect this family member's information. 
            Relationships with other family members remain intact.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EditMemberForm;